import MInputWrapper from './m-input-wrapper.vue';

export default MInputWrapper;
